import type { ReactNode } from "react";

type Variant = "ok" | "warn" | "danger" | "neutral";

const variantMap: Record<Variant, string> = {
  ok: "bg-accent-soft text-accent-text",
  warn: "bg-warn-bg text-warn-text",
  danger: "bg-danger-bg text-danger-text",
  neutral: "bg-bg-app text-text-muted",
};

export function Badge({
  variant = "neutral",
  children,
}: {
  variant?: Variant;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded uppercase tracking-wider text-[10.5px] font-bold ${variantMap[variant]}`}
    >
      {children}
    </span>
  );
}
